import React, { useState } from 'react';

const PreRomaneio = () => {
  const [romaneios, setRomaneios] = useState([]);
  const [newRomaneio, setNewRomaneio] = useState({
    driverName: '',
    vehiclePlate: '',
    route: '',
    departureDate: '',
    arrivalDate: '',
    pdfFile: null,
    vehicle: null
  });
  const [errors, setErrors] = useState({});

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setNewRomaneio({ ...newRomaneio, [name]: value });
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file && file.type === 'application/pdf') {
      setNewRomaneio({ ...newRomaneio, pdfFile: file });
      setErrors({ ...errors, pdfFile: '' });
    } else {
      setErrors({ ...errors, pdfFile: 'Por favor, selecione um arquivo PDF.' });
    }
  };

  const handleVehicleSelect = (vehicle) => {
    setNewRomaneio({ ...newRomaneio, vehicle });
  };

  const validateForm = () => {
    let formErrors = {};
    if (!newRomaneio.driverName) formErrors.driverName = 'Nome do motorista é obrigatório';
    if (!newRomaneio.vehiclePlate) formErrors.vehiclePlate = 'Placa do veículo é obrigatória';
    if (!newRomaneio.route) formErrors.route = 'Rota é obrigatória';
    if (!newRomaneio.departureDate) formErrors.departureDate = 'Data de saída é obrigatória';
    if (!newRomaneio.arrivalDate) formErrors.arrivalDate = 'Data de chegada é obrigatória';
    if (!newRomaneio.pdfFile) formErrors.pdfFile = 'Arquivo PDF é obrigatório';
    if (!newRomaneio.vehicle) formErrors.vehicle = 'Veículo é obrigatório';
    setErrors(formErrors);
    return Object.keys(formErrors).length === 0;
  };

  const handleAddRomaneio = () => {
    if (validateForm()) {
      setRomaneios([...romaneios, newRomaneio]);
      setNewRomaneio({
        driverName: '',
        vehiclePlate: '',
        route: '',
        departureDate: '',
        arrivalDate: '',
        pdfFile: null,
        vehicle: null
      });
      setErrors({});
    }
  };

  return (
    <div className="flex w-full justify-center items-center min-h-screen bg-gray-100">
      <div className="w-full max-w-6xl p-8 bg-white rounded-lg shadow-lg">
        <h1 className="text-4xl font-bold mb-8 text-center text-gray-800">Pré-Romaneio</h1>
        
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          <div className="bg-white p-8 rounded-lg shadow-md">
            <h2 className="text-3xl font-semibold mb-6 text-gray-700">Cadastro de Romaneio</h2>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div>
                <input
                  type="text"
                  name="driverName"
                  value={newRomaneio.driverName}
                  onChange={handleInputChange}
                  placeholder="Nome do Motorista"
                  className={`p-4 border rounded-md w-full ${errors.driverName ? 'border-red-500' : 'border-gray-300'}`}
                />
                {errors.driverName && <p className="text-red-500 text-sm mt-1">{errors.driverName}</p>}
              </div>
              <div>
                <input
                  type="text"
                  name="vehiclePlate"
                  value={newRomaneio.vehiclePlate}
                  onChange={handleInputChange}
                  placeholder="Placa do Veículo"
                  className={`p-4 border rounded-md w-full ${errors.vehiclePlate ? 'border-red-500' : 'border-gray-300'}`}
                />
                {errors.vehiclePlate && <p className="text-red-500 text-sm mt-1">{errors.vehiclePlate}</p>}
              </div>
              <div>
                <input
                  type="date"
                  name="departureDate"
                  value={newRomaneio.departureDate}
                  onChange={handleInputChange}
                  placeholder="Data de Saída"
                  className={`p-4 border rounded-md w-full ${errors.departureDate ? 'border-red-500' : 'border-gray-300'}`}
                />
                {errors.departureDate && <p className="text-red-500 text-sm mt-1">{errors.departureDate}</p>}
              </div>
              <div>
                <input
                  type="date"
                  name="arrivalDate"
                  value={newRomaneio.arrivalDate}
                  onChange={handleInputChange}
                  placeholder="Data de Chegada"
                  className={`p-4 border rounded-md w-full ${errors.arrivalDate ? 'border-red-500' : 'border-gray-300'}`}
                />
                {errors.arrivalDate && <p className="text-red-500 text-sm mt-1">{errors.arrivalDate}</p>}
              </div>
              <div>
                <input
                  type="file"
                  accept="application/pdf"
                  onChange={handleFileChange}
                  className="p-4 border rounded-md w-full"
                />
                {errors.pdfFile && <p className="text-red-500 text-sm mt-1">{errors.pdfFile}</p>}
              </div>
            </div>
            <button
              onClick={handleAddRomaneio}
              className="mt-8 bg-blue-600 text-white p-4 rounded-md w-full hover:bg-blue-700 transition duration-200"
            >
              Adicionar Romaneio
            </button>
          </div>

          <div className="bg-white p-8 rounded-lg shadow-md">
            <h2 className="text-3xl font-semibold mb-6 text-gray-700">Relatório de Romaneios</h2>
            <table className="min-w-full bg-white">
              <thead>
                <tr>
                  <th className="py-3 px-6 border-b">Nome do Motorista</th>
                  <th className="py-3 px-6 border-b">Placa do Veículo</th>
                  <th className="py-3 px-6 border-b">Rota</th>
                  <th className="py-3 px-6 border-b">Data de Saída</th>
                  <th className="py-3 px-6 border-b">Data de Chegada</th>
                  <th className="py-3 px-6 border-b">Arquivo PDF</th>
                </tr>
              </thead>
              <tbody>
                {romaneios.map((romaneio, index) => (
                  <tr key={index} className="hover:bg-gray-100 transition duration-200">
                    <td className="border px-6 py-3">{romaneio.driverName}</td>
                    <td className="border px-6 py-3">{romaneio.vehiclePlate}</td>
                    <td className="border px-6 py-3">{romaneio.route}</td>
                    <td className="border px-6 py-3">{romaneio.departureDate}</td>
                    <td className="border px-6 py-3">{romaneio.arrivalDate}</td>
                    <td className="border px-6 py-3">
                      {romaneio.pdfFile ? (
                        <a href={URL.createObjectURL(romaneio.pdfFile)} target="_blank" rel="noopener noreferrer" className="text-blue-500 hover:underline">
                          Ver PDF
                        </a>
                      ) : (
                        'Nenhum arquivo'
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PreRomaneio;